import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { GreenText } from 'components'
import { InspectionCompanyInformationDto } from 'dtos/companies'
import { Form, Formik } from 'formik'
import { InspectionCompanyInformationDtoValidator } from 'validators/companies'

interface Props {
  initialValues: InspectionCompanyInformationDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: InspectionCompanyInformationDto) => void
  open: boolean
}

export default function InspectionCompanyDialog({ initialValues, isLoading, onClose, onSave, open }: Props) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={values => onSave(values)}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={InspectionCompanyInformationDtoValidator}
      >
        {({ errors, handleBlur, handleChange, touched, values }) => {
          return (
            <Form>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Inspection Company</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading}
                      error={Boolean(touched.inspectionCompanyCode && errors.inspectionCompanyCode)}
                      helperText={touched.inspectionCompanyCode && errors.inspectionCompanyCode}
                      label='Inspection Company Code'
                      name='inspectionCompanyCode'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.inspectionCompanyCode ?? ''}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`**Inspection Company Code:**

A free-text field with a 25-character limit, allowing users to input the company's unique code.

The Inspection Company Code is used on the Ohio Titles Out of State Motor Vehicle Physical Inspection form in the “Dealer Permit Number” field.

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any changes

**SAVE Button:**

Clicking the SAVE button will save any changes.`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
